import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { EventsService } from '../event/event.service';
import { UtilsService } from '../utils/utils.service';


@Injectable({
  providedIn: 'root',
})
export class LobbyStateService {

  activeKeyword: Map<string, any>;
  private customerGotIPADWindow = false;
  private activeTab;
  private searchTerm;
  public currentKeywordSubject: Subject<any>;
  public firstTopKeyword: any;

  constructor(
    private eventService: EventsService,
    private utilsService: UtilsService,
    // private googleToolsService: GoogleToolsService,
  ) {
    this.activeKeyword = new Map();
    this.currentKeywordSubject = new ReplaySubject(1);
  }

  public setCurrentKeywordSubject(data: any) {
    this.currentKeywordSubject.next(data);
  }

  public getCurrentKeywordSubject() {
    return this.currentKeywordSubject;
  }

  saveActiveKeyword(keyword, lobbyName) {
    this.activeKeyword.set(lobbyName, keyword);
  }

  currentActiveKeyword(lobbyName) {
    return this.activeKeyword.get(lobbyName);
  }

  showIPADWindow() {
    return !this.customerGotIPADWindow;
  }

  setSearchTerm(search) {
    this.searchTerm = search;
  }

  getSearchTerm() {
    return this.searchTerm;
  }
  setIPADWindowOpen() {
    this.customerGotIPADWindow = true;
  }

  setIPADWindowReset() {
    this.customerGotIPADWindow = false;
  }

  setFirstTopKeyword(keyword) {
    this.firstTopKeyword = keyword;
  }

  getFirstTopKeyword() {
    return this.firstTopKeyword;
  }

  saveActiveTab(tabName) {
    this.activeTab = tabName.toLowerCase();
    let search = window.location.search;
    search = (search) ? search : "";
    //update metatags 
    //this.LobbyService.updateMeta(tabName.toLowerCase());
    //push history

    if (tabName.toLowerCase() != "casino") {
      this.utilsService.pushHistoryState(tabName + search)
    }

    this.eventService.publish("event:saveActiveTab", this.activeTab)
    // this.googleToolsService.sendWebViewEvent();
  }

  currentActiveTab() {
    return (!!this.activeTab) ? this.activeTab : 'casino'
  }
}
